import { TechnicalMessage } from '@api/types';
import { TextCodes } from '@api/types/translation/TextCodes';
import {
  SmartLink,
  StyledTableRow,
  StyledTableRowSeparator,
  TableCell,
  TechnicalMessageUpdateFiltersProps,
  useTechnicalMessageContext,
} from '@components';
import { useAppSelector, useAuth } from '@hooks';
import { getSpecialPage } from '@store/app/app.slice';
import { t } from '@translations';
import { getTextFromHtml } from '@utils/text.utils';
import { getMessageItems, messagesColumns } from './technicalMessage.config';

type TechnicalMessageListItemProps = {
  message: TechnicalMessage;
  isWorking?: boolean;
};

export const TechnicalMessageListRow = ({ message, isWorking }: TechnicalMessageListItemProps) => {
  const messageItems = getMessageItems(message);
  const { filters } = useTechnicalMessageContext();
  const searchWords =
    filters
      .find((filter: TechnicalMessageUpdateFiltersProps) => filter.filterName === 'Search')
      ?.value?.split(' ') ?? [];

  const technicalMessageDetailsBaseUrl = useAppSelector(
    getSpecialPage('technicalMessageDetailsPage')
  ) as string;
  const technicalMessageDetailsHref = `${technicalMessageDetailsBaseUrl}?id=${message.id}`;
  const { isBeremaUser } = useAuth();

  const statusTranslation = (status: string) => {
    switch (status) {
      case 'Important':
        return t(TextCodes.TechnicalMessage.Status.Important);
      case 'Critical':
        return t(TextCodes.TechnicalMessage.Status.Critical);
      case 'Information':
        return t(TextCodes.TechnicalMessage.Status.Information);
      default:
        return status;
    }
  };

  return (
    <StyledTableRow iscursorpointer='true'>
      <SmartLink
        href={technicalMessageDetailsHref}
        sx={{ display: 'contents', p: 8 }}
        className='link'
      >
        {messageItems.map((item) => (
          <TableCell
            key={item.fieldName}
            isWorking={isWorking}
            searchWords={['title', 'text'].includes(item.fieldName) ? searchWords : []}
            filteredColumns={messagesColumns()}
            visibleColumnNames={messagesColumns().map((message) => message.key.toLowerCase())}
            fieldValue={statusTranslation(getTextFromHtml(item.fieldValue || ''))}
            fieldName={item.fieldName}
            isBold={!isBeremaUser && item.isBold}
          />
        ))}
        <StyledTableRowSeparator />
      </SmartLink>
    </StyledTableRow>
  );
};
